import { render } from "./user_level.vue?vue&type=template&id=2b9f7678&scoped=true&ts=true"
import script from "./user_level.vue?vue&type=script&lang=ts"
export * from "./user_level.vue?vue&type=script&lang=ts"

import "./user_level.vue?vue&type=style&index=0&id=2b9f7678&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9f7678"]])

export default __exports__